import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  modalHeader: {
    [theme.breakpoints.down('sm')]: {
      paddingTop: 16,
      width: '100%',
      background: '#F5F6FA',
    },
  },
  modalHeaderTitle: {
    [theme.breakpoints.down('sm')]: {
      textAlign: 'center',
    },
  },
}))

export default useStyles
